import Api from './rest/CompanyDepartment';

export default new Api();
